import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { TenantUsersScreen } from "./TenantUsersScreen";
import { UserScreen } from "../user";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface UsersRoutesProps {
  tenant: Tenant;
}
export const UsersRoutes: FunctionComponent<UsersRoutesProps> = ({
  tenant
}) => {
  return (
    <Routes>
      <Route path=":userId" element={<UserScreen />} />
      <Route path="*" element={<TenantUsersScreen tenant={tenant} />} />
    </Routes>
  );
};
